import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  StudentCyclesResponseModel,
  StudentSchoolCycleDetailModel,
} from '@core/models';
import { Api } from '@core/services/api.state';
import { ApiService } from '@core/services/api/api.service';
import { environment } from '@env/environment';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StudentCyclesService extends Api<StudentCyclesResponseModel> {
  override endpoint: string;

  constructor(
    protected override readonly apiService: ApiService<StudentCyclesResponseModel>,
    private http: HttpClient
  ) {
    super(apiService);
    this.endpoint = `${environment.apiUrl}/v1/admin/students/studentCycles`;
  }

  public disableStudentSchoolCycle(data: {
    status: 'string';
    student_school_cycle_id: 'string';
    ticket_number: 'string';
  }): Observable<any> {
    const apiUrl = `${environment.apiUrl}/v1/admin/students/studentSchoolCycle/inactivate`;
    return this.http.post(apiUrl, data);
  }

  public enableStudentSchoolCycle(data: {
    student_school_cycle_id: 'string';
    ticket_number: 'string';
  }): Observable<any> {
    const apiUrl = `${environment.apiUrl}/v1/admin/students/studentSchoolCycle/activate`;
    return this.http.post(apiUrl, data);
  }

  public getStudentSchoolCycleDetail(
    studentCycleId: string
  ): Observable<StudentSchoolCycleDetailModel[]> {
    const apiUrl = `${environment.apiUrl}/v1/admin/students/studentSchoolCycle/additionalInfo/${studentCycleId}`;
    return this.http.get(apiUrl).pipe(map((response: any) => response.data));
  }

  public regenerateStudentSchoolCycle(data: {
    frequency: 'string';
    student_school_cycle_id: 'string';
    ticket_number: 'string';
  }): Observable<any> {
    const apiUrl = `${environment.apiUrl}/v1/admin/students/studentSchoolCycle/regenerate`;
    return this.http.post(apiUrl, data);
  }
}
